/**
 * 6 桁ルームコードのアルファベットと正規化。
 * サーバ (mixed-worker/src/code.rs) と同じ 31 文字集合 (0/O/1/I/L 除外)。
 */

export const ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
export const CODE_LEN = 6;

const SET = new Set(ALPHABET);

/** 1 文字を大文字化し、 ALPHABET に無い文字 (混同しやすい 0/O/1/I/L 含む) は null。 */
export function normalizeCodeChar(ch: string): string | null {
  const upper = ch.toUpperCase();
  return SET.has(upper) ? upper : null;
}

export function isValidCode(s: string): boolean {
  if (s.length !== CODE_LEN) return false;
  for (const c of s) {
    if (!SET.has(c)) return false;
  }
  return true;
}

import { navigate } from './navigate';

export function navigateToRoom(code: string): void {
  navigate(`/r/${code}`);
}
